import { ProgramSessionSet, ProgramSessionSetCreateRequest, ProgramSessionSetSearchFilter, ProgramSessionSetSearchRequest, ProgramSessionSetSearchResponse, SessionSet, SetSearchFilter, SetSearchResponse, SetTransitByExerciseRequest, SetTransitByExerciseResponse } from "src/api/entities";
import { IWorkoutSessionSetTransitApiClients, WorkoutSessionSetTransitApiClients } from "./workout.session.set.transit.client";

export interface IWorkoutSessionSetTransitApiService {
    transitBySession(request: SetTransitByExerciseRequest): Promise<SetTransitByExerciseResponse>;
}

export class WorkoutSessionSetTransitApiService implements IWorkoutSessionSetTransitApiService {
    private static instance: WorkoutSessionSetTransitApiService;
    private api: IWorkoutSessionSetTransitApiClients;

    private constructor(basePath: string) {
        this.api = WorkoutSessionSetTransitApiClients.getInstance(basePath);
    }

    static getInstance(basePath: string) {
        if (WorkoutSessionSetTransitApiService.instance == null) {
            WorkoutSessionSetTransitApiService.instance = new WorkoutSessionSetTransitApiService(basePath);
        }
        return WorkoutSessionSetTransitApiService.instance;
    }

    async transitBySession(request: SetTransitByExerciseRequest): Promise<SetTransitByExerciseResponse> {
        return (await this.api.setTransitControllerApi.transitBySession(request)).data;
    }
}
